import React from "react";

import { Route, Routes } from "react-router-dom";

import WorkspaceDelete from "./WorkspaceDelete";
import WorkspaceJoin from "./WorkspaceJoin";
import WorkspaceSettings from "./WorkspaceSettings";
import WorkspaceTransfer from "./WorkspaceTransfer";
import WorkspaceWizard from "./WorkspaceWizard";

const WorkspaceRoutes = () => {
  return (
    <Routes>
      <Route path="new" element={<WorkspaceWizard />} />
      <Route path="invitation" element={<WorkspaceJoin />} />
      {/** /join will auto accept the invite */}
      <Route path="join" element={<WorkspaceJoin />} />
      <Route path="transfer" element={<WorkspaceTransfer />} />
      <Route path="delete" element={<WorkspaceDelete />} />
      <Route path=":workspaceId/*" element={<WorkspaceSettings />} />
    </Routes>
  );
};

export default WorkspaceRoutes;
